import { normalizeIngredientName } from '../ingredients/normalize-name.js';
import { mergeShoppingItems } from './merge.js';
const hasAmount = (item) => item.quantity !== null || !!item.quantityText;
export function decideShoppingAdd(existing, incoming, options = {}) {
    const key = normalizeIngredientName(incoming.name);
    // Two different products are two entries, also under the same name: spaghetti are never
    // merged into – or made to re-activate – the gnocchi that were scanned before them.
    const otherProduct = (e) => !!options.productId && !!e.productId && e.productId !== options.productId;
    const sameName = existing.filter((e) => normalizeIngredientName(e.name) === key && !otherProduct(e));
    // 1. An open item that can absorb the new one (same name, compatible unit).
    for (const open of sameName.filter((e) => !e.checked)) {
        const merged = mergeShoppingItems([open, incoming]);
        if (merged.length !== 1)
            continue;
        const nothingNew = !hasAmount(incoming) && !hasAmount(open) && incoming.refs.length === 0;
        if (nothingNew)
            return {
                outcome: 'UNCHANGED',
                targetId: open.id,
                result: { ...open, note: open.note ?? incoming.note ?? null },
            };
        const { normalizedName: _n, mergedCount: _c, ...result } = merged[0];
        // The item keeps the name it already has on the list.
        return { outcome: 'MERGED', targetId: open.id, result: { ...result, name: open.name } };
    }
    // 2. Something bought before: re-activate it instead of creating a duplicate. The old
    //    quantity describes a finished purchase, so it is replaced (or kept) – never summed.
    const bought = sameName
        .filter((e) => e.checked)
        .sort((a, b) => (b.checkedAt ?? '').localeCompare(a.checkedAt ?? ''))[0];
    if (bought) {
        const keep = options.reactivateQuantity === 'KEEP';
        const amount = keep ? bought : incoming;
        return {
            outcome: 'REACTIVATED',
            targetId: bought.id,
            result: {
                name: bought.name,
                quantity: amount.quantity,
                quantityMax: amount.quantityMax,
                quantityText: amount.quantityText,
                unitCode: amount.unitCode,
                unitText: amount.unitText,
                note: incoming.note ?? bought.note ?? null,
                // References of the old purchase are dropped; new ones are attached.
                refs: [...incoming.refs],
            },
        };
    }
    // 3. New on this list (also: an open item with an incompatible unit – "2 cans" vs "500 g").
    return { outcome: 'CREATED', targetId: null, result: { ...incoming, refs: [...incoming.refs] } };
}
/** True when re-activating would change a quantity the user might want to keep. */
export function reactivationNeedsQuestion(bought, incoming) {
    if (bought.quantity === null && !bought.quantityText)
        return false;
    return (bought.quantity !== incoming.quantity ||
        (bought.unitCode ?? bought.unitText ?? null) !==
            (incoming.unitCode ?? incoming.unitText ?? null) ||
        (bought.quantityText ?? null) !== (incoming.quantityText ?? null));
}
//# sourceMappingURL=add-decision.js.map